(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["thioufoot-delivery-estimate"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('thioufoot-delivery')) {
  class ThioufootDelivery extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      clearInterval(this.timer);
      this.controller = new AbortController();
      this.select = this.querySelector('select');
      if (!this.select) return;
      this.select.addEventListener('change', () => this.update(), {signal:this.controller.signal});
      document.addEventListener('visibilitychange', () => this.update(), {signal:this.controller.signal});
      this.update();
      this.timer = setInterval(() => this.update(), 60000);
    }
    disconnectedCallback() {
      this.controller?.abort();
      clearInterval(this.timer);
    }
    holiday(date) {
      const y = date.getUTCFullYear();
      const fixed = ['1-1','5-1','5-8','7-14','8-15','11-1','11-11','12-25'];
      const key = (date.getUTCMonth()+1)+'-'+date.getUTCDate();
      if (fixed.includes(key)) return true;
      const a=y%19,b=Math.floor(y/100),c=y%100,d=Math.floor(b/4),e=b%4,f=Math.floor((b+8)/25),g=Math.floor((b-f+1)/3),h=(19*a+b-d-g+15)%30,i=Math.floor(c/4),k=c%4,l=(32+2*e+2*i-h-k)%7,m=Math.floor((a+11*h+22*l)/451);
      const easter = new Date(Date.UTC(y,Math.floor((h+l-7*m+114)/31)-1,(h+l-7*m+114)%31+1));
      return [1,39,50].some(offset => {
        const day=new Date(easter);day.setUTCDate(day.getUTCDate()+offset);
        return day.getTime()===date.getTime();
      });
    }
    addDays(date, count) {
      const result = new Date(date);
      while(count>0) {
        result.setUTCDate(result.getUTCDate()+1);
        if (![0,6].includes(result.getUTCDay()) && !this.holiday(result)) count--;
      }
      return result;
    }
    update() {
      const parts = new Intl.DateTimeFormat('en-CA',{timeZone:'Europe/Paris',year:'numeric',month:'2-digit',day:'2-digit'}).formatToParts(new Date());
      const part = type => parts.find(p=>p.type===type).value;
      const today=new Date(Date.UTC(Number(part('year')),Number(part('month'))-1,Number(part('day'))));
      const format=new Intl.DateTimeFormat(this.dataset.locale || 'fr',{day:'numeric',month:'short',timeZone:'UTC'});
      const range=(a,b)=>a.getTime()===b.getTime()?format.format(a):format.format(a)+' – '+format.format(b);
      const [min,max]=this.select.value.split(',').map(Number);
      const early=this.addDays(today,1),late=this.addDays(today,2);
      this.querySelector('[data-ordered]').textContent=format.format(today);
      this.querySelector('[data-dispatch]').textContent=range(early,late);
      this.querySelector('[data-arrival]').textContent=range(this.addDays(early,min),this.addDays(late,max));
      this.hidden=false;
    }
  }
  customElements.define('thioufoot-delivery',ThioufootDelivery);
}
  } catch(e) { console.error(e); }
})();

})();
